var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastersfilledicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.25C9.75 6.90686 8.40683 8.25 6.75 8.25C5.09315 8.25 3.75 6.90686 3.75 5.25C3.75 3.59315 5.09315 2.25 6.75 2.25C8.40683 2.25 9.75 3.59315 9.75 5.25Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.25C12.9068 8.25 14.25 6.90686 14.25 5.25C14.25 3.59315 12.9068 2.25 11.25 2.25",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.5H5.25C3.17894 10.5 1.5 12.179 1.5 14.25C1.5 15.0785 2.17157 15.75 3 15.75H10.5C11.3285 15.75 12 15.0785 12 14.25C12 12.179 10.3211 10.5 8.25 10.5Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.5C14.8211 10.5 16.5 12.179 16.5 14.25C16.5 15.0785 15.8285 15.75 15 15.75H13.875",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastersfilledicon);
export default __webpack_public_path__ + "static/media/mastersfilledicon.0745165f8ed5e937da753592cd124b90.svg";
export { ForwardRef as ReactComponent };